export const FETCH_ROLES_START = `[melius][roles] Get roles start`;
export const FETCH_ROLES_SUCCESS = `[melius][roles] Get roles success`;
export const FETCH_ROLES_FAIL = `[melius][roles] Get roles fail`;

export const FETCH_SPECIFIC_ROLE_START = `[melius][role] Get specific role start`;
export const FETCH_SPECIFIC_ROLE_SUCCESS = `[melius][rols] Get specific role success`;
export const FETCH_SPECIFIC_ROLE_FAIL = `[melius][rols] Get specific role fail`;
